import {useLocation} from "react-router-dom";

/**
 * Hook to get the query param in url
 */
export const useQuery = () => new URLSearchParams(useLocation().search);
